import { ROOT_STATUS } from '.';

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_PENDING: {
    key: 'STATUS_PENDING',
    value: 'Pending',
    color: 'secondary',
    icon: '',
  },
  STATUS_REQUIRE_GUARDIAN_INFO: {
    key: 'STATUS_REQUIRE_GUARDIAN_INFO',
    value: 'Require Guardian Info',
    color: 'secondary',
    icon: '',
  },
  STATUS_ONGOING: {
    key: 'STATUS_ONGOING',
    value: 'Pending',
    color: 'primary',
    icon: '',
  },
  STATUS_READY_TO_EVALUATE: {
    key: 'STATUS_READY_TO_EVALUATE',
    value: 'Ready to evaluate',
    color: 'secondary',
    icon: '',
  },
  STATUS_EVALUATING: {
    key: 'STATUS_EVALUATING',
    value: 'Evaluating',
    color: 'secondary',
    icon: '',
  },
  STATUS_EXCEPTION: {
    key: 'STATUS_EXCEPTION',
    value: 'Exception',
    color: 'error',
    icon: '',
  },
  STATUS_COMPLETED: {
    key: 'STATUS_COMPLETED',
    value: 'Completed',
    color: 'primary',
    icon: '',
  },
};

export const NEGATIVE_RULE_FLAGS = {
  1: {
    color: '#2A9D8F',
    text: 'Minimal',
  },
  2: {
    color: '#E9C46A',
    text: 'Low',
  },
  3: {
    color: '#F4A261',
    text: 'Moderate',
  },
  4: {
    color: '#E76F51',
    text: 'High',
  },
  5: {
    color: '#E14749',
    text: 'Severe',
  },
  11: {
    color: '#2A9D8F',
    text: 'Suitable',
  },
  13: {
    color: '#F4A261',
    text: 'Further Review',
  },
  15: {
    color: '#E14749',
    text: 'Not Suitable',
  },
};

export const NEGATIVE_STATUSES = {
  ...ROOT_STATUS,
  NEGATIVE_STATUS_CONCERNED: {
    key: 'NEGATIVE_STATUS_CONCERNED',
    value: 'Concerns',
    color: 'error',
    icon: '',
  },
  NEGATIVE_STATUS_NO_CONCERN: {
    key: 'NEGATIVE_STATUS_NO_CONCERN',
    value: 'No concerns',
    color: 'success',
    icon: '',
  },
};
export const LEVELS = {
  LEVEL_NOT_SUITABLE: {
    value: 'LEVEL_NOT_SUITABLE',
    text: 'Not Suitable',
  },
  LEVEL_HIGH_RISK: {
    value: 'LEVEL_HIGH_RISK',
    text: 'High Risk',
  },
  LEVEL_SUITABLE: {
    value: 'LEVEL_SUITABLE',
    text: 'Suitable',
  },
  LEVEL_LOW_RISK: {
    value: 'LEVEL_LOW_RISK',
    text: 'Low Risk',
  },
  LEVEL_FURTHER_REVIEW: {
    value: 'LEVEL_FURTHER_REVIEW',
    text: 'Further Review',
  },
  LEVEL_MODERATE_RISK: {
    value: 'LEVEL_MODERATE_RISK',
    text: 'Moderate Risk',
  },
};

export const HCS_LEVELS = {
  HCS_LEVEL_COULD_BE_BETTER: 'HCS_LEVEL_COULD_BE_BETTER',
  HCS_LEVEL_GOOD: 'HCS_LEVEL_GOOD',
  HCS_LEVEL_VERY_GOOD: 'HCS_LEVEL_VERY_GOOD',
};
